<template lang="pug">
  y-dialog(fill-height fluid v-model="showModal" scrollable transition="fade-transition" persistent max-width="600px")
    v-card
      v-card-title.pa-4.border-bottom(style="background-color: var(--v-basic100)")
        v-row(no-gutters)
          v-col
            p.mb-0.h6.basic800--text {{ $t('update_company') }}

      v-card-text.pa-0
        v-form(ref="form")
          v-card.pa-4(style="overflow-x: hidden;")
          
            .company-name
              div.label.basic600--text.text-uppercase {{$t('company_name.label')}}
              v-text-field.mt-2(v-model='name' :placeholder="$t('company_name.placeholder')" dense outlined height="40" background-color="basic200" :rules="rules.not_empty")
            
            .company-phone
              div.label.basic600--text.text-uppercase {{$t('company_phone.label')}}
              y-phone-input.my-4(v-model="phone")

            .company-registration-number
              div.label.basic600--text.text-uppercase {{$t('registration_number.label')}}
              v-text-field.mt-2(v-model='registrationNumber' :placeholder="$t('registration_number.placeholder')" dense outlined height="40" background-color="basic200" :rules="rules.not_empty")
            
            .company-address
              div.label.basic600--text.text-uppercase {{$t('address_1.label')}}
              v-text-field.mt-2(v-model="address.address_1" :placeholder="$t('address_1.placeholder')" dense outlined height="40" background-color="basic200" :rules="rules.not_empty")
              div.label.basic600--text.text-uppercase {{$t('address_2.label')}}
              v-text-field.mt-2(v-model="address.address_2" :placeholder="$t('address_2.placeholder')" dense outlined height="40" background-color="basic200" :rules="rules.not_empty")
              div.label.basic600--text.text-uppercase {{$t('postcode.label')}}
              v-text-field.mt-2(v-model="address.postcode" :placeholder="$t('postcode.placeholder')" dense outlined height="40" background-color="basic200" :loading="isLoading" :rules="rules.not_empty" @keyup="fetchPostcodes(address.postcode)")
              div.label.basic600--text.text-uppercase {{$t('city.label')}}
              v-text-field.mt-2(v-model="address.city" :placeholder="$t('city.placeholder')" dense outlined height="40" background-color="basic200" :loading="isLoading" :rules="rules.not_empty")
              div.label.basic600--text.text-uppercase {{$t('state.label')}}
              v-text-field.mt-2(v-model="address.state" :placeholder="$t('state.placeholder')" dense outlined height="40" background-color="basic200" :loading="isLoading" :rules="rules.not_empty")
              div.label.basic600--text.text-uppercase {{$t('country.label')}}
              v-text-field.mt-2(v-model="address.country" :placeholder="$t('country.placeholder')" dense outlined height="40" background-color="basic200" :loading="isLoading" :rules="rules.not_empty")

            .company-tax-rate
              div.label.basic600--text.text-uppercase {{$t('tax_rate.label')}}
              v-text-field.mt-2(v-model='taxRate' :placeholder="$t('tax_rate.placeholder')" dense outlined height="40" background-color="basic200" :rules="rules.tax_rate" type="number" suffix="%" min=0 max=100)

      v-card-actions.pa-4
        v-spacer
        v-btn(text @click='showModal = false' depressed height=32)
          .button-Aa-small.primary400--text| {{ $t('cancel') }}
        v-btn(color='textColorAccent' depressed height=32 :loading="isLoading" dark @click="clickSave")
          .button-AA-small.basic100--text| {{ $t('update') }}

</template>

<script>
import { mapActions } from 'vuex'

export default {
  name: 'UpdateCompanyDetailsDialog',
  props: ['open', 'company'],
  data: () => ({
    name: null,
    phone: null,
    registrationNumber: null,
    taxRate: 0,
    address: {},
    isLoading: false,
    rules: {
      not_empty: [val => (val || '').length > 0 || 'This field is required'],
      tax_rate: [
        v => (!!v || parseInt(v) == 0 ) || 'This field is required', 
        v => v <= 100 || 'Tax rate should not be above 100%',
      ]
    }
  }),
  computed: {
    showModal: {
      get() {
        return this.open
      },
      set(newValue) {
        this.$emit('update:open', newValue)
      }
    },
    companyDetails: {
      get() {
        return this.company
      },
      set(newValue) {
        this.$emit('update:company', newValue)
      }
    }
  },
  mounted () {
    this.name = this.company.name
    this.phone = this.company.phone
    this.registrationNumber = this.company.registration_number
    this.taxRate = this.company.tax_rate || 0
    this.address = this.company.address || {}
  },
  methods: {
    ...mapActions([
      'showMessage'
    ]),
    fetchPostcodes (val) {
      console.log('hai')
      if (!val) {
        return
      }
      if (val.length !== 5) {
        return
      }
      this.isLoading = true
      this.$axios.get(`/shipping/postcodes?postcode=${this.address.postcode}`).then((response) => {
        const addresses = response.data
        if (addresses.length > 0 && addresses[0].postcode) {
          this.$set(this.address, 'city', addresses[0].city)
          this.$set(this.address, 'state', addresses[0].state)
          this.$set(this.address, 'country', addresses[0].country)
        }
      })
      .catch(() => {
      })
      .finally(() => {
        this.isLoading = false
      })
    },
    clickSave() {
      if (!this.$refs.form.validate()) {
        return
      }
      this.isLoading = true
      var params = new FormData()
      params.set('name', this.name)
      params.set('phone', this.phone)
      params.set('registration_number', this.registrationNumber)
      params.set('tax_rate', this.taxRate)
      this.axios.patch(`/companies/${this.company.id}/`, { address: this.address })
        .finally(() => {
          this.axios.patch(`/companies/${this.company.id}/`, params)
            .then(resp => {
              this.companyDetails = resp.data
              this.showModal = false
            })
            .catch(() => {
              this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
            })
            .finally(() => {
              this.isLoading = false
            })
        })
    }
  }
}
</script>

<style scoped>
.border-bottom{
    border-bottom: 1px solid var(--v-basic300);
    border-radius: 0 !important;
}
.container-image {
  border-style: solid;
  border-width: 1px;
  border-color: grey;
  border-radius: 2px;
  width: 120px;
}
.file-layout {
  position: relative;
}
.input-layout {
  position: absolute;
  top: 0px;
  left: 0px;
  right: 0px;
  bottom: 0px;
  opacity: 0;
}
.v-text-field--outlined >>> fieldset {
  border-color: var(--v-primary200);
}
</style>

<i18n>
{
  "en": {
    "update_company": "Update company details",
    "company_logo": "Company logo",
    "company_name": {
      "label": "Company Name",
      "placeholder": "Write your company name here"
    },
    "company_phone": {
      "label": "Phone No",
      "placeholder": "Write your company phone number here"
    },
    "registration_number": {
      "label": "Company Registration No",
      "placeholder": "Write your company registration number here"
    },
    "address_1": {
      "label": "Address Line 1",
      "placeholder": "e.g. K-3-01, Conezion, Persiaran IRC3"
    },
    "address_2": {
      "label": "Address Line 2",
      "placeholder": "e.g. IOI Resort City"
    },
    "postcode": {
      "label": "Postcode",
      "placeholder": "e.g. 62502"
    },
    "city": {
      "label": "City",
      "placeholder": "e.g. Putrajaya"
    },
    "state": {
      "label": "State",
      "placeholder": "e.g. Wilayah Persekutuan Putrajaya"
    },
    "country": {
      "label": "Country",
      "placeholder": "e.g. Malaysia"
    },
    "tax_rate": {
      "label": "Tax rate",
      "placeholder": "Default tax rate for price calculation"
    }
  },
  "id": {
    "update_company": "Update Detail Perusahaan",
    "company_logo": "Logo perusahaan",
    "company_name": {
      "label": "Nama Perusahaan",
      "placeholder": "Write your company name here"
    },
    "company_phone": {
      "label": "Nomor Telepon",
      "placeholder": "Write your company phone number here"
    },
    "registration_number": {
      "label": "No Registrasi Perusahaan",
      "placeholder": "Write your company registration number here"
    },
   "address_1": {
      "label": "Nama Jalan, Gedung, No Rumah, RT/RW, Kelurahan",
      "placeholder": "e.g. Jalan Prof. Joko Sutono Sh No.999, RT.14/RW.6, Petogogan, "
    },
    "address_2": {
      "label": "Kecamatan",
      "placeholder": "Kec. Kby. Baru"
    },
    "postcode": {
      "label": "Kode Pos",
      "placeholder": "12160"
    },
    "city": {
      "label": "Kota",
      "placeholder": "Kota Jakarta Selatan"
    },
    "state": {
      "label": "Provinsi",
      "placeholder": "DKI Jakarta"
    },
    "country": {
      "label": "Country",
      "placeholder": "e.g. Indonesia"
    },
    "tax_rate": {
      "label": "Persentase Pajak",
      "placeholder": "Default tax rate for price calculation"
    }
  }
}
</i18n>
